import { BaseIcon, type IconSize } from './BaseIcon';

interface NavIconProps {
  code: string;
  size?: IconSize;
  className?: string;
  responsive?: boolean;
  width?: number;
  height?: number;
}

/**
 * NavIcon component for displaying navigation icons
 * Uses responsive image handling by default for better quality
 */
export function NavIcon({
  code,
  size = 'small',
  className = '',
  responsive = true,
  width,
  height,
}: NavIconProps) {
  return (
    <BaseIcon
      code={code}
      size={size}
      className={className}
      directory="nav"
      responsive={responsive}
      width={width}
      height={height}
    />
  );
}
